export default "__VITE_ASSET__DptvNJVs__"